import { apiClient } from "../config";

async function getReviewers(programId: number) {
    const res = await apiClient.get(`/admin/programs/${programId}/reviewers`);
    return res.data;
}

export default getReviewers;
